module.exports = __webpack_public_path__ + "static/media/attraction.1cef06a6.png";